import { T, useTheme, Ico, Btn, Badge, Sheet } from '../../../design';

export interface BulkResultView {
  kind: 'enroll' | 'cancel';
  okCount: number;
  awaitingCredit?: number;
  enrolledNames?: string[];
  cancelled?: Array<{ name: string; awaitingCredit: boolean }>;
  skipped?: Array<{ name: string; reason: string }>;
}

export function BulkResultSheet({ result, onClose }: { result: BulkResultView; onClose: () => void }) {
  const t = useTheme();
  return (
    <Sheet onClose={onClose} title={result.kind === 'enroll' ? 'Bulk-tilmelding' : 'Bulk-afmelding'}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '12px 14px', borderRadius: 14, background: T.accentLight, marginBottom: 14 }}>
        <span style={{ width: 38, height: 38, borderRadius: 11, background: t.accent, color: T.onAccent, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Ico.checkCircle size={20} /></span>
        <div>
          <div style={{ fontSize: 15, fontWeight: 800, color: T.fg }}>{result.okCount} {result.kind === 'enroll' ? 'tilmeldt' : 'afmeldt'}</div>
          {result.kind === 'cancel' && (result.awaitingCredit ?? 0) > 0 && <div style={{ fontSize: 12, color: T.info, fontWeight: 600, marginTop: 2 }}>{result.awaitingCredit} venter på kreditnota</div>}
        </div>
      </div>
      {result.kind === 'enroll' && result.enrolledNames && result.enrolledNames.length > 0 && (
        <div style={{ marginBottom: 12 }}>{result.enrolledNames.map((n) => <div key={n} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 2px', fontSize: 13.5, fontWeight: 600, color: T.fg }}><Ico.check size={15} style={{ color: t.accent }} />{n}</div>)}</div>
      )}
      {result.kind === 'cancel' && result.cancelled && result.cancelled.length > 0 && (
        <div style={{ marginBottom: 12 }}>{result.cancelled.map((c, i) => <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '7px 2px', fontSize: 13.5, fontWeight: 600, color: T.fg }}><span style={{ display: 'flex', gap: 8, alignItems: 'center' }}><Ico.check size={15} style={{ color: t.accent }} />{c.name}</span><Badge tone={c.awaitingCredit ? 'info' : 'neutral'}>{c.awaitingCredit ? 'Afventer kredit' : 'Annulleret'}</Badge></div>)}</div>
      )}
      {result.skipped && result.skipped.length > 0 && (
        <div style={{ borderTop: `1px solid ${T.borderLight}`, paddingTop: 10 }}>
          <div style={{ fontSize: 10.5, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: T.fg3, marginBottom: 6 }}>Sprunget over · {result.skipped.length}</div>
          {result.skipped.map((s, i) => <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 2px', fontSize: 13, fontWeight: 600, color: T.fg2 }}><span>{s.name}</span><span style={{ fontSize: 11.5, color: T.fg3 }}>{s.reason}</span></div>)}
        </div>
      )}
      <Btn full size="lg" onClick={onClose} style={{ marginTop: 14 }}>Færdig</Btn>
    </Sheet>
  );
}
